import { IsArray, IsString } from 'class-validator';

export class ProvisionEcommerceDeactivationDto {
	@IsArray()
	@IsString({ each: true })
	public tenantAliases!: Array<string>;
}